import { SERVER_URL } from "./config";

const groupNames = ["group-1"];

function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}

const mrStatementDataObject = {
    total_debit_amount: "",
    // total_pkgs: "",
    // total_weight: "",
    // total_bilties:""
  };
  
  const mrStatementGroupInfo = {
    "group-1": [
      {
        label: "Debit Amount",
        className: "form-row-m",
        labelClassName: "form-label-w",
        inputClassName: "form-input",
        name: "total_debit_amount",
        type: "text",
        placeHolder: "1234",
        idClearanceNeeded: "item_id",
        onChangeIgnoreClearance: ["description"],
      },
    ],
  };

  export {
    groupNames,
    mrStatementGroupInfo,
    mrStatementDataObject,
  };